import { Controller } from "@hotwired/stimulus"

/**
 * Handles promotional 2-year commitment checkbox on payment method cards.
 * When checked, shows promotional pricing (30% off year 1) and updates duration field.
 * All pricing is pre-calculated server-side - no JavaScript math.
 */
export default class extends Controller {
  static targets = [
    "checkbox",
    "standardPrice",
    "promotionalPrice",
    "standardBreakdown",
    "promotionalBreakdown",
    "durationField"
  ]

  connect() {
    queueMicrotask(() => {
      if (this.hasCheckboxTarget) {
        this.toggle()
      }
    })
  }

  toggle() {
    const isPromotional = this.checkboxTarget.checked

    // Toggle price displays
    this.standardPriceTargets.forEach(el => el.classList.toggle("hidden", isPromotional))
    this.promotionalPriceTargets.forEach(el => el.classList.toggle("hidden", !isPromotional))

    // Toggle breakdown displays
    this.standardBreakdownTargets.forEach(el => el.classList.toggle("hidden", isPromotional))
    this.promotionalBreakdownTargets.forEach(el => el.classList.toggle("hidden", !isPromotional))

    // Update hidden duration field
    if (this.hasDurationFieldTarget) {
      this.durationFieldTarget.value = isPromotional ? "two_year" : "standard"
    }
  }
}
